import React, { useState, useEffect } from 'react'
import PageContainer from '../../components/PageContainer'
import { Link } from 'react-router-dom'
import { PageHeader } from '../../components/Layout/PageHeader'
import { Box } from '@mui/system'
import { PatientDetailText } from "../../components/Patient/PatientDetailText";
import { Typography, Button, Checkbox, FormControl, TextField, InputLabel, Select, MenuItem, FormGroup, FormControlLabel, Switch } from '@mui/material'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { FromToPickerDate } from "../../components/FromToPicker";
import { DataGrid } from '@mui/x-data-grid';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditIcon from '@mui/icons-material/Edit';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { EventLogService } from '../../services/DataService'
import { LogService } from '../../services/DataService'
import { UserService, DeviceService } from '../../services/DataService'
import { Translate, Localize, translate } from 'react-i18nify';
import { useParams, useNavigate } from 'react-router-dom';
import { SystemDetailPopUp } from '../../components/SystemDetailPopUp'
import TimeUtils from '../../utils/TimeUtils'
import PatientDashboardCategory from "../../components/Patient/PatientDashboardCategory";
import {UpdatesBanner} from "../../components/UpdatesBanner";
import { DatePicker } from '@mui/lab';
import { TestResultTable, TestResultTableAccordion } from '../../components/Test/TestResultsTable'

export const HotDevice = () => {


    const [device, setDevice] = useState([]);
    const [eventLogs, setEventLogs] = useState([]);
    const [logs, setLogs] = useState([]);
    const { udsn } = useParams();
    const navigate = useNavigate();
    const [severityCheckbox, setSeverityCheckbox] = useState({"0": false, "1": false, "2": false, "3": true, "4": true});
    const [eventsFrom, setEventsFrom] = useState(new Date()); // todays date
    const [eventsTo, setEventsTo] = useState(new Date()); // todays date
    const [filteredEventLogs, setFilteredEventLogs] = useState([]);
    const [notifyHealthcareActive, setNotifyHealthcareActive] = useState(false);

    
    const [systemLogOpen, setSystemLogOpen] = useState(false)
    const [systemLogData, setSystemLogData] = useState()

    const [userRoleLocations, setUserRoleLocations] = useState([]);
    const [isO2maticDeviceManager, setIsO2maticDeviceManager] = useState(false);

    // const [logsFrom, setLogsFrom] = useState(TimeUtils.getBeginningOfDay(new Date()))
    const [logsFrom, setLogsFrom] = useState()


    const openSystemLog = (systemLogData) => {
        setSystemLogData(systemLogData)
        setSystemLogOpen(true)
    }
    const closeSystemLog = () => {
        setSystemLogOpen(false)
    }

    useEffect(() => {
        (async () => {
            await UserService.getActiveUserRolesLocations()
            .then((data) => {
                setUserRoleLocations(data.data);
            }).catch((error) => {
                console.log(error);
            })
            EventLogService.getLatestByUdsn(udsn).then((result) => {
                setLogsFrom(TimeUtils.getBeginningOfDay(new Date(result.data)));
            }).catch((error) => {
                console.error(error);
            })
        })();
    }, [])

    // get locations of user with repairer role
    useEffect(() => {
        let isO2maticDeviceManager = false;
        if(userRoleLocations.length !== 0){
            userRoleLocations.forEach(role => {
                if(role.roleName === "DeviceManager" && role.locationId === 21){
                    isO2maticDeviceManager = true;
                }
            })
        }
        setIsO2maticDeviceManager(isO2maticDeviceManager);
    },[userRoleLocations])

    useEffect(() => {
        (async () => {
            let deviceResult = await DeviceService.getHotByUdsn(udsn);
            let logResult = await LogService.getDeviceLogs(udsn);
            setDevice(deviceResult.data);
            setLogs(logResult.data); // system logs
        })();
    }, [])

    useEffect(() => { // check if event log contains "notify healthcare" event (ID 125)
        const hasEventType125 = eventLogs.some(event => event.eventtype.id === 125);
        setNotifyHealthcareActive(hasEventType125);
    }, [eventLogs])

    useEffect(() => { // filter event logs based on severity checkboxes
        const filteredEventLogs = eventLogs.filter((event) => {
            const logSeverity = event.eventtype.severity;
            return severityCheckbox[logSeverity] === true;
        });
        setFilteredEventLogs(filteredEventLogs);
    }, [severityCheckbox, eventLogs])

    useEffect(() => {
        getEventLogsFrom();
    }, [logsFrom])


    const getEventLogsFrom = () => {
        if(logsFrom != null){
            const logsToDate = TimeUtils.getEndingOfDay(logsFrom);
            EventLogService.getWithAllParameters(udsn, TimeUtils.localToUtc(logsFrom), TimeUtils.localToUtc(logsToDate), false).then((eventLogResult) => {
                setEventLogs(eventLogResult.data); // device logs
            }).catch((error) => {
                console.log(error);
            });
        }
    }

    const handleEdit = () => {
        navigate("/device/HOT/" + udsn + "/edit", { replace: true });
    }

    const handleChangeCheckbox = (event) => {
        if (event.target.name == "3") {
            setSeverityCheckbox({
                ...severityCheckbox,
                [event.target.name]: event.target.checked,
                ["4"]: event.target.checked,
              });
        } else {
            setSeverityCheckbox({
                ...severityCheckbox,
                [event.target.name]: event.target.checked,
              });
        }
    };
    

    const columns = [
        {
            field: 'timestamp', headerName: translate('Timestamp'), minWidth:150, flex: 1,
            /* valueGetter: (log) => {
                var parts = new Date(log.row.timestamp).toISOString().split("T")
                return parts[0] + " " + parts[1].slice(0, 8);
            } */
            valueGetter: (log) => {
                return TimeUtils.utcToLocal(log.row.timestamp, true)
            }
        },
        {
            field: 'severity', headerName: translate('Severity'), minWidth:100,
            valueGetter: (log) => {
                return log.row.eventtype.severity;

            }
        },
        {
            field: 'eventTypeId', headerName: translate('Id'), minWidth:100,
            valueGetter: (log) => {
                return log.row.eventtype.id;

            }
        },
        {
            field: 'eventType', headerName: translate('EventType'), minWidth:150, flex: 2,
            valueGetter: (log) => {
                return log.row.eventtype.name
            }
        },
        {
            field: 'parameter', headerName: translate('Parameter'), minWidth:150, flex: 2,
            valueGetter: (log) => {
                if(!log.row.parameterDescription || log.row.parameterDescription === ""){
                    return ""
                }else{
                    return "" + log.row.parameterDescription + "";
                }
                // var parameter = log.row.parameter;
                // return parameter == 0 ? "Off" : "On";

            }
        },

    ];

    const logColumns = [
        {
            field: 'user', headerName: translate('User'), minWidth:150,            
            valueGetter: (params) => {
                return(`${params?.value?.name} (${params?.value?.id})`)
            },

        },
        {
            field: 'logAction', headerName: translate('Action'), minWidth:100,

        },
        {
            field: 'timestamp', headerName: translate('Timestamp'), minWidth: 150,
            valueGetter: (params) => {
                try {
                    let oldDate = params.value
                    let addUtc = TimeUtils.addUTCTimezone(oldDate)
                    return TimeUtils.formatDate(addUtc)
                }
                catch (e) {
                    return params.value
                }
            },

        },
        {
            field: 'verbose', headerName: translate('Description'), flex: 1,

        }


    ];

    return (
        <PageContainer>
            <PageHeader leftAlign><Translate value="HotDeviceDetails" /></PageHeader>

            <UpdatesBanner update_description="UpdatesDescriptionHOTPage"/>

            <Box sx={{width: { xs: "100%", sm: "100%", md: "100%", lg: "1000px" }, maxWidth: {md: "1000px"}}}>

                <Box sx={{ width:"100%"-"30px", mt: 1, borderRadius: "15px", border: 1, borderColor: "primary.main", bgcolor: "primary.main", color: "primary.contrastText", p: 2, display: "flex", justifyContent: 'space-between', flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" }}}>
            
                    <Box sx={{flexGrow: 1, display: 'flex', flexDirection: 'column'}}>
                        <Typography variant="body">
                            {<Translate value="DeviceSerialNumber" />}
                        </Typography>
                        <PatientDashboardCategory
                            title={device?.udsn? device.udsn : "-"}
                        >
                        </PatientDashboardCategory>

                        <Box sx={{mt: 2}}>
                            <PatientDetailText
                                label={<Translate value="Id" />}
                                value={device?.id? device.id : "-" }
                            ></PatientDetailText>
                            <PatientDetailText
                                label={<Translate value="UDSN" />}
                                value={device?.udsn? device.udsn : "-" }
                            ></PatientDetailText>
                            <PatientDetailText
                                label={<Translate value="PUID" />}
                                value={device?.puid? device.puid : "-"}
                            ></PatientDetailText>
                            <PatientDetailText
                                label={<Translate value="MAC" />}
                                value={device?.mac? device.mac : "-" }
                            ></PatientDetailText>
                        </Box>

                        <Box sx={{mt: 2, flexGrow: 1}}>
                            <PatientDetailText
                                label={<Translate value="Status" />}
                                value={device?.status?.value? <Translate value={device.status.value}/> : "-" }
                            ></PatientDetailText>
                            <PatientDetailText
                                label={<Translate value="DeviceOwner" />}
                                value={device?.owner?.name? device.owner.name : "-"}
                            ></PatientDetailText>
                            <PatientDetailText
                                label={<Translate value="DeviceLocation" />}
                                value={device?.location?.name? device.location.name : "-"}
                            ></PatientDetailText>
                        </Box>
                        {userRoleLocations.find(role => role.roleName === "DeviceManager")?
                        <>
                            <Button onClick={handleEdit} sx={{ mt: 2 , width:"200px", }} color="secondary" variant="contained" startIcon={<EditIcon />}>
                                <Translate value="EditDevice" />
                            </Button>
                        </>
                        : 
                        <></>
                        }
                    </Box>

                    <Box component="img" sx={{
                    width: { xs: "0%", sm: "0%", md: "30%", lg: "30%" },
                    p: { md: 5 , lg: 5}
                    }} src="../HOT.svg" />

                </Box>

            </Box>

            <Accordion sx={{ width: { xs: "100%", sm: "100%", md: "100%", lg: "1000px" }, maxWidth: {md: "1000px"}, mt: 2 }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography variant="h5"><Translate value="DeviceLog" /></Typography>
                </AccordionSummary>

                <AccordionDetails>

                    {notifyHealthcareActive?
                    <Box sx={{borderRadius: "15px", border: 1, borderColor: "#E03C32", bgcolor: "#E03C32", color: "primary.contrastText", display: 'flex', justifyContent: 'center', p:1}}>
                        <Translate value="NofityHealthcareMessage" />
                    </Box>
                    :
                    null
                    }

                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>

                        
                    <DatePicker
                            views={['year', 'day']}
                            labelId={"EventLogsFrom"}
                            label={<Translate value="From" />}
                            //format='YYYY/MM/DD' // does not work
                            timezone="UTC"
                            value={logsFrom}
                            disableFuture={true}
                            minDate={new Date().setFullYear('2010')}
                            maxDate={new Date()}
                            ampm={false}
                            renderInput={(params) => <TextField size="small" sx={{ mr: 2, mb: 1, width:"150px"}} {...params} helperText={null}/>}
                            onChange={(newValue) => {
                            }}
                            onAccept={(newValue) => {
                                // props.setFromValue(TimeUtils.getBeginningOfDay(newValue));
                                setLogsFrom(TimeUtils.getBeginningOfDay(newValue));
                                // getEventLogsFrom();
                            }}
                        />

                        <Box sx={{mx:4}}>
                        
                            <Translate value="ShowEventsDescription" />:

                            <Checkbox
                                checked={severityCheckbox["1"]}
                                onChange={handleChangeCheckbox}
                                inputProps={{ 'aria-label': 'controlled' }}
                                name={"1"}
                                sx={{'&.Mui-checked': {color: "#7BB662"}}}
                                />
                            <Translate value="Low" />
                            

                            <Checkbox
                                checked={severityCheckbox["2"]}
                                onChange={handleChangeCheckbox}
                                inputProps={{ 'aria-label': 'controlled' }}
                                name={"2"}
                                sx={{'&.Mui-checked': {color: "#FFD301"}}}
                                />
                            <Translate value="Medium" />
                            
                            <Checkbox
                                checked={severityCheckbox["3"]}
                                onChange={handleChangeCheckbox}
                                inputProps={{ 'aria-label': 'controlled' }}
                                name={"3"}
                                sx={{'&.Mui-checked': {color: "#E03C32"}}}
                                />
                            <Translate value="High" />

                        </Box>
                    </Box>

                    <DataGrid
                        ColumnWidth="*"
                        sx={{ height: 480, mt: 2 }}
                        columns={columns}
                        rows={filteredEventLogs}
                        pageSize={100}
                        rowsPerPageOptions={[100]}
                        overflowY="auto"
                    getRowId={(row) => row.id}
                        
                    />
                </AccordionDetails>
            </Accordion>
            {isO2maticDeviceManager?
            <Box>
            <Accordion sx={{ width: { xs: "100%", sm: "100%", md: "100%", lg: "1000px" }, maxWidth: {md: "1000px"}, p:0 }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    sx={{ width:"100%" }}
                >
                    <Typography variant="h5"><Translate value="Tests" /></Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ width:"100%" }} >
                    <TestResultTable udsn={udsn} gridWidth={{ xs: "100%", sm: "100%", md: "100%", lg: "968px" }}  />
                </AccordionDetails>
            </Accordion>
            <Accordion sx={{ width: { xs: "100%", sm: "100%", md: "100%", lg: "1000px" }, maxWidth: {md: "1000px"} }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography variant="h5"><Translate value="SystemLog" /></Typography>
                </AccordionSummary>

                <AccordionDetails>
                    <DataGrid
                        ColumnWidth="*"
                        sx={{ height: 480, mt: 2 }}
                        columns={logColumns}
                        rows={logs}
                        onRowClick={
                            (params, event, detail) => {
                                openSystemLog(params.row)
                            }
                        }
                        pageSize={100}
                        rowsPerPageOptions={[100]}
                    />
                </AccordionDetails>
            </Accordion>
            </Box>
            : null }

            <SystemDetailPopUp systemlog={systemLogData} onClose={closeSystemLog} open={systemLogOpen} />

        </PageContainer>
    )
}
